export const getLabList = (store) => store.lab.data;

export const getPaginationInfo = (store) => {
  const { data, ...rest } = store.lab;
  return rest;
};
